{
  "EMOJI": {
    "PLACEHOLDER": "Zoek emojis",
    "NOT_FOUND": "Er zijn geen overeenkomende emoji's gevonden",
    "REMOVE": "Verwijderen"
  }
}
